import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/main.layout";
import Homepage from "../pages/home";
import HowItWorks from "../pages/how-it-works";
import FAQs from "../pages/faqs";
import CaseStudies from "../pages/case-studies";
import Contact from "../pages/contact";
import DigitalExperience from "../pages/digital-experience";
import PrivacyPolicy from "../pages/privacy-policy";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: "/",
                element: <Homepage />
            },
            {
                path: '/how-it-works',
                element: <HowItWorks />
            },
            {
                path: '/faqs',
                element: <FAQs />
            },
            {
                path: '/case-studies',
                element: <CaseStudies />
            },
            {
                path: '/contact',
                element: <Contact />
            },
            {
                path: '/digital-experience',
                element: <DigitalExperience />
            },
            {
                path: '/privacy-policy',
                element: <PrivacyPolicy />
            }
        ]
    }
]);
